import DefaultButton from '@components/Atoms/DefaultButton';
import Modal from '@components/Modal';
import classNames from 'classnames';
import { Parser } from 'html-to-react';
import React from 'react';
import styles from './index.module.scss';

export const ViewThoughtCommentModal: React.FunctionComponent<ViewCommentModalProps> = (props) => {
  const { title, isOpen, onClose, children } = props;

  return (
    <div className={styles.root}>
      <Modal
        open={isOpen}
        setOpen={onClose}
        overlay
        onTapBackgroundClose
        className={styles.modalRoot}
      >
        <DefaultButton color="primary" type="button" className={styles.btnClose} onClick={onClose}>
          <i className={classNames('icon', 'icon-x', styles.btnCloseIcon)} />
        </DefaultButton>

        <div className={styles.modalBody}>
          <div className={styles.modalTitle}>{title}</div>
          <hr />

          <div>{Parser().parse(children)}</div>
        </div>
      </Modal>
    </div>
  );
};

interface ViewCommentModalProps {
  title: string | undefined;
  isOpen: boolean;
  onClose: () => void | undefined;
  children: React.ReactNode;
}
